import i18n from "i18next";

/**
 * Get the full preprompt text based on current language
 */
export const getStandardPreprompt = (): string => {
  const t = i18n.t.bind(i18n);

  const cellReferences = t("preprompt.cellReferences");
  const cellRule =
    cellReferences && !cellReferences.startsWith("preprompt.cellReferences")
      ? `\n\n${cellReferences}`
      : "";

  const editProposals = t("preprompt.editProposals");
  const editRule =
    editProposals && !editProposals.startsWith("preprompt.editProposals")
      ? `\n\n${editProposals}`
      : "";

  // Try to get the full preprompt first
  const fullPreprompt = t("preprompt.full");

  // If the full version exists and is not just the key, use it
  if (fullPreprompt && !fullPreprompt.startsWith("preprompt.full")) {
    return fullPreprompt + cellRule + editRule;
  }

  // Otherwise, build it from parts
  const system = t("preprompt.system");
  const instructions = [
    `1. ${t("preprompt.instructions.analyze")}`,
    `2. ${t("preprompt.instructions.provide")}`,
    `3. ${t("preprompt.instructions.suggest")}`,
    `4. ${t("preprompt.instructions.explain")}`,
    `5. ${t("preprompt.instructions.offer")}`,
  ].join("\n");

  const attachmentNote = t("preprompt.attachmentNote");

  return `${system}\n\n${instructions}\n\n${attachmentNote}${cellRule}${editRule}`;
};

/**
 * Get a shorter version of the preprompt (for display purposes)
 */
export const getShortPreprompt = (): string => {
  const t = i18n.t.bind(i18n);
  return t("preprompt.system");
};
